module.exports = __webpack_public_path__ + "img/empty_img.dd2aaf9.png";